import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { CellMonthly } from './cell-monthly';
import { filterActiveMetrics, orderMetrics } from './header-semi-annually';
const MONTH_KEYS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Total'];
interface HeaderMonthlyProps {
  title: string;
  headerTable: MetricValues[];
  activeMetrics: string[];
}
function HeaderMonthly(t0) {
  const $ = _c(15);
  const {
    title,
    activeMetrics,
    headerTable
  } = t0;
  let t1;
  if ($[0] !== activeMetrics || $[1] !== headerTable) {
    t1 = filterActiveMetrics(activeMetrics, headerTable);
    $[0] = activeMetrics;
    $[1] = headerTable;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const metricsActive = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex min-h-[93px] flex-1 items-center justify-start overflow-hidden rounded-xl whitespace-pre", "bg-muted shadow-sm", "[&::-webkit-scrollbar]:h-0 [&::-webkit-scrollbar]:w-0");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("flex h-12 w-[195px] items-center py-2.5 pl-8", "3xl:min-w-[230px]");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <div className={t3}><div className="text-foreground max-w-full pr-2 text-base leading-normal font-bold wrap-break-word">{title}</div></div>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== activeMetrics || $[8] !== metricsActive) {
    t5 = MONTH_KEYS.map((month, index) => <CellMonthly key={month} metrics={metricsActive[index] ?? {}} title={month} activeMetrics={orderMetrics(undefined, activeMetrics)} isTotal={month === "Total"} />);
    $[7] = activeMetrics;
    $[8] = metricsActive;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="flex flex-1 flex-col items-center"><div className="flex w-full flex-row items-center justify-between py-2.5">{t5}</div></div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className={t2}><div className="flex flex-1 flex-row items-center 2xl:max-w-[1312px]">{t4}{t6}</div></div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
export { HeaderMonthly };